import { createRoot } from "react-dom/client";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/en-nz";
import { LicenseInfo } from "@mui/x-license";

import { ListingFilterProvider, PortalFramework, Settings } from "@sal/portal";
import Routes from "./Routes";

import logo from "./images/systemair_logo.png";
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import { PortalTheme } from "./Theme";

import "./fonts/fonts.css";

const pfSettings: Settings = {
	logoUrl: logo,
	loginTitle: "Specification Portal",
	defaultColorMode: "light", //TODO-JC: Change back to System once Dark Mode issues are resolved
	useAdapterDayjs: true
};

LicenseInfo.setLicenseKey(process.env.MUI_X_PRO_LICENSE_KEY || "");

dayjs.extend(updateLocale);
dayjs.updateLocale("en-nz", {
	weekStart: 1
});
dayjs.locale("en-nz");

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
	<PortalFramework settings={pfSettings}>
		<PortalTheme>
			<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-nz">
				<ListingFilterProvider>
					<Routes />
				</ListingFilterProvider>
			</LocalizationProvider>
		</PortalTheme>
	</PortalFramework>);
